import Icon from "../../../Elements/Icon/Icon.tsx";
import FilesPreviewComponent from "./FilesPreviewComponent.js";
import { DownloadpageActionComponent } from "./DownloadpageActionComponent.js";
import StatusElement from "./StatusElement.tsx";
import MailType from "../Reusable/MailType.tsx";
import SenderInfo from "./SenderInfo/SenderInfo.tsx";
import LabelTagList from "../Reusable/LabelTagList.tsx";
import MobileActionListPopup from "../Reusable/MobileActionListPopup.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import RestoreButton from "../Reusable/RestoreButton.tsx";
import config from "config";
import { useAppSelector } from "store/hooks.ts";
import { selectFParam, selectTParam } from "store/selectors/inboxSelectors.ts";

const MobileMailFooter = ({ data, setShowSideBar }) => {
  const pageCategory = useAppSelector(selectFParam);

  const footerActionsList =
    data.mailStatus === "removed"
      ? [
          {
            icon: "info",
            action: () => {
              setShowSideBar({ name: "info", data: data });
            },
          },
        ]
      : [
          {
            icon: "info",
            action: () => {
              setShowSideBar({ name: "info", data: data });
            },
          },
          {
            icon: "share-solid",
            action: () => {
              setShowSideBar({ name: "share", data: data });
            },
          },
          ...(pageCategory === "jform"
            ? [
                {
                  icon: "alog",
                  textKey: `jmform-api-call-text`,
                  action: () => {
                    setShowSideBar({ name: "alog", data: data });
                  },
                },
              ]
            : [
                {
                  icon: "alock",
                  action: () => {
                    setShowSideBar({ name: "alock", data: data });
                  },
                },
              ]),
        ];

  return (
    <div className="mail-footer">
      <div className="actions-group">
        {footerActionsList
          .filter((item) => item.icon)
          .map((item) => (
            <div className="action-icon" key={item.icon}>
              <Icon name={item.icon} gray onClick={item.action} />
            </div>
          ))}
      </div>
      <div className="additional-actions-footer">
        {/* <InboxCommentsIconComponent data={data} /> */}
        <div className="download-button-wrapper">
          <DownloadpageActionComponent data={data} hideAdditioanlIcons />
        </div>
      </div>
    </div>
  );
};

const InboxMobileListMail = ({ data, setShowSideBar }) => {
  const { getTextByKey, getPath } = useContent();
  const pageType = useAppSelector(selectTParam);
  const pageCategory = useAppSelector(selectFParam);

  const baseUrl = data?.bucketName
  ? data.bucketName.includes("jumbomail1")
    ? window.location.origin
    : data.bucketName.replace("files.", "")
  : config.baseurl;

  return (
    <div className="inbox-mobile-mail">
      <div className="mail-header">
        <div className="mail-header-top">
          <div>
            {pageCategory === "jform" ? (
              <div className="mail-subject">
                <a
                  href={`${baseUrl}${getPath()}gallery/${data.id}`}
                  rel="noopener noreferrer"
                >
                  {data.deliveryNumber}
                </a>
                <StatusElement data={data} />
              </div>
            ) : (
              <div className="mail-subject">
                <a
                  href={`${baseUrl}${getPath()}gallery/${data.id}`}
                  rel="noopener noreferrer"
                >
                  {data.subject || getTextByKey("no-subject")}
                </a>
              </div>
            )}
          </div>
          <MailType {...data} />
          {pageType !== "trash" ? (
            <MobileActionListPopup
              data={data}
              setShowSideBar={setShowSideBar}
            />
          ) : (
            <RestoreButton data={data} listItemRef={null} />
          )}
        </div>
        <div className="sender-and-status-row">
          <SenderInfo
            {...data?.SenderInfo}
            relatedTo={data?.relatedTo}
            deletedUserFullName={data?.deletedUserFullName}
            creationDate={data?.creationDate}
            filesQuantity={data?.filesQuantity}
            totalSize={data?.filesSize}
            recipients={data?.recipientsList}
            recipientInfo={data?.RecipientInfo}
            isOutbox={data?.isOutbox}
            isCompactView
          />
          {pageCategory === "jform" ? null : <StatusElement data={data} />}
          <LabelTagList labelIds={data?.labelIds} encryptedMailId={data.id} />
        </div>
      </div>
      <FilesPreviewComponent data={data} />
      <MobileMailFooter data={data} setShowSideBar={setShowSideBar} />
    </div>
  );
};

export default InboxMobileListMail;
